import React from 'react';

import Context from '../../../../../../context';

import {CustomIcon, TableNullData} from '../../../../../../components';

import './index.sass';
import {locationNamespace} from "../../../../../../types/location.namespace";

type Props = {
  data: any;
};

const Body: React.FC<Props> = ({ data }: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { setSelectedProvince, setShowModal } = React.useContext(Context.Location.Province);
  const docs = data?.data?.result?.docs;

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickUpdate(province: locationNamespace.province.index): void {
    setSelectedProvince!(province);
    setShowModal!('UPDATE');
  }

  function onClickDelete(province: locationNamespace.province.index): void {
    setSelectedProvince!(province);
    setShowModal!('DELETE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <tbody id="location-province-body-wrapper">
      {docs?.map((province: locationNamespace.province.index, index: number) => (
        <tr key={`location-province-tr-${index}`}>
          <td className="table-text">
            {province.name}
          </td>
          <td className="table-options-wrapper">
            <CustomIcon icon={'fas fa-pencil'         } type='primary' hoverTitle={'ویرایش'} onClick={() => onClickUpdate(province)} />
            <CustomIcon icon={'fas fa-trash-can-xmark'} type='danger'  hoverTitle={'حذف'   } onClick={() => onClickDelete(province)} />
          </td>
        </tr>
      ))}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Body;
